var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { Center } from './Center';
import { ConnectionStatus } from './ConnectionStatus';
import { CustomNotification } from './CustomNotification';
import { MessageListInner } from './MessageListInner';
import { MessageNotification as DefaultMessageNotification, } from './MessageNotification';
import { Attachment as DefaultAttachment } from '../Attachment';
import { Avatar as DefaultAvatar } from '../Avatar';
import { DateSeparator as DefaultDateSeparator } from '../DateSeparator';
import { EmptyStateIndicator as DefaultEmptyStateIndicator } from '../EmptyStateIndicator';
import { EventComponent } from '../EventComponent';
import { LoadingIndicator as DefaultLoadingIndicator } from '../Loading';
import { MessageSimple } from '../Message';
import { defaultPinPermissions, MESSAGE_ACTIONS } from '../Message/utils';
import { TypingIndicator as DefaultTypingIndicator } from '../TypingIndicator';
import { useChannelContext, useChatContext, useTranslationContext, } from '../../context';
var MessageListWithContext = /** @class */ (function (_super) {
    __extends(MessageListWithContext, _super);
    function MessageListWithContext(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollToBottom = function () {
            _this._scrollToRef(_this.bottomRef, _this.messageList);
        };
        _this._scrollToRef = function (el, parent) {
            var scrollDown = function () {
                if (el && el.current && parent && parent.current) {
                    _this.scrollToTarget(el.current, parent.current);
                }
            };
            scrollDown();
            // scroll down after images load again
            setTimeout(scrollDown, 200);
        };
        /**
         * target - target to scroll to (DOM element, scrollTop Number, 'top', or 'bottom'
         * containerEl - DOM element for the container with scrollbars
         * source: https://stackoverflow.com/a/48429314
         */
        _this.scrollToTarget = function (target, containerEl) {
            var scrollTop;
            if (target instanceof HTMLElement) {
                scrollTop = target.offsetTop;
            }
            else if (typeof target === 'number') {
                scrollTop = target;
            }
            else if (target === 'top') {
                scrollTop = 0;
            }
            else if (target === 'bottom') {
                scrollTop = containerEl.scrollHeight - containerEl.offsetHeight;
            }
            if (scrollTop !== undefined) {
                containerEl.scrollTop = scrollTop;
            }
        };
        _this.goToNewMessages = function () {
            _this.scrollToBottom();
            _this.setState({ newMessagesNotification: false });
        };
        _this.userScrolledUp = function () {
            return (_this.scrollOffset || 0) > _this.props.scrolledUpThreshold;
        };
        _this.listenToScroll = function (offset, reverseOffset, threshold) {
            _this.scrollOffset = offset;
            _this.closeToTop = reverseOffset < threshold;
            if (_this.state.newMessagesNotification && !_this.userScrolledUp()) {
                _this.setState({ newMessagesNotification: false });
            }
        };
        _this.onMessageLoadCaptured = function () {
            // A load event (emitted by e.g. an <img>) was captured on a message.
            // In some cases, the loaded asset is larger than the placeholder, which means we have to scroll down.
            if (!_this.userScrolledUp() && !_this.closeToTop) {
                _this.scrollToBottom();
            }
        };
        _this.loadMore = function () {
            if (_this.props.loadMore) {
                if (_this.props.messageLimit) {
                    _this.props.loadMore(_this.props.messageLimit);
                }
                else {
                    _this.props.loadMore(100);
                }
            }
        };
        _this.state = {
            newMessagesNotification: false,
        };
        _this.bottomRef = React.createRef();
        _this.messageList = React.createRef();
        return _this;
    }
    MessageListWithContext.prototype.componentDidMount = function () {
        var _a;
        // start at the bottom
        this.scrollToBottom();
        var messageListRect = (_a = this.messageList.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        this.setState({
            messageListRect: messageListRect,
        });
    };
    MessageListWithContext.prototype.getSnapshotBeforeUpdate = function (prevProps) {
        var _a, _b;
        if (this.props.threadList) {
            return null;
        }
        // Are we adding new items to the list?
        // Capture the scroll position so we can adjust scroll later.
        if ((((_a = prevProps.messages) === null || _a === void 0 ? void 0 : _a.length) || 0) < (((_b = this.props.messages) === null || _b === void 0 ? void 0 : _b.length) || 0)) {
            var list = this.messageList.current;
            if (list) {
                return {
                    offsetBottom: list.scrollHeight - list.scrollTop,
                    offsetTop: list.scrollTop,
                };
            }
            else {
                return null;
            }
        }
        return null;
    };
    MessageListWithContext.prototype.componentDidUpdate = function (prevProps, _, snapshot) {
        var _a, _b, _c, _d, _e, _f, _g;
        // If we have a snapshot value, we've just added new items.
        // Adjust scroll so these new items don't push the old ones out of view.
        // (snapshot here is the value returned from getSnapshotBeforeUpdate)
        var userScrolledUp = this.userScrolledUp();
        var currentLastMessage = (_a = this.props.messages) === null || _a === void 0 ? void 0 : _a[((_b = this.props.messages) === null || _b === void 0 ? void 0 : _b.length) - 1];
        var previousLastMessage = (_c = prevProps.messages) === null || _c === void 0 ? void 0 : _c[((_d = prevProps.messages) === null || _d === void 0 ? void 0 : _d.length) - 1];
        if (!previousLastMessage || !currentLastMessage) {
            return;
        }
        var hasNewMessage = currentLastMessage.id !== previousLastMessage.id;
        var lastHasNewReaction = ((_e = currentLastMessage.latest_reactions) === null || _e === void 0 ? void 0 : _e.length) !== ((_f = previousLastMessage.latest_reactions) === null || _f === void 0 ? void 0 : _f.length);
        var lastHasNewReply = currentLastMessage.reply_count !== previousLastMessage.reply_count;
        var isOwner = ((_g = currentLastMessage === null || currentLastMessage === void 0 ? void 0 : currentLastMessage.user) === null || _g === void 0 ? void 0 : _g.id) === this.props.client.userID;
        var list = this.messageList.current;
        // always scroll down when it's your own message that you added...
        var scrollToBottom = (hasNewMessage || lastHasNewReaction || lastHasNewReply) && (isOwner || !userScrolledUp);
        if (scrollToBottom) {
            this.scrollToBottom();
            // remove the scroll notification if we already scrolled down...
            if (this.state.newMessagesNotification)
                this.setState({ newMessagesNotification: false });
            return;
        }
        if (snapshot !== null) {
            // Maintain the offsetTop of scroll so that content in viewport doesn't move.
            // This is for the case where user has scroll up significantly and a new message arrives from someone.
            if (hasNewMessage) {
                if (this.messageList.current) {
                    this.scrollToTarget(snapshot.offsetTop, this.messageList.current);
                }
            }
            else {
                // Maintain the bottomOffset of scroll.
                // This is for the case of pagination, when more messages get loaded.
                if (this.messageList.current) {
                    this.scrollToTarget(((list === null || list === void 0 ? void 0 : list.scrollHeight) || 0) - snapshot.offsetBottom, this.messageList.current);
                }
            }
        }
        // Check the scroll position... if you're scrolled up show a little notification
        if (hasNewMessage && !this.state.newMessagesNotification) {
            this.setState({ newMessagesNotification: true });
        }
    };
    MessageListWithContext.prototype.render = function () {
        var _a = this.props, addNotification = _a.addNotification, _b = _a.Attachment, Attachment = _b === void 0 ? DefaultAttachment : _b, _c = _a.Avatar, Avatar = _c === void 0 ? DefaultAvatar : _c, _d = _a.DateSeparator, DateSeparator = _d === void 0 ? DefaultDateSeparator : _d, _e = _a.EmptyStateIndicator, EmptyStateIndicator = _e === void 0 ? DefaultEmptyStateIndicator : _e, internalInfiniteScrollProps = _a.internalInfiniteScrollProps, _f = _a.LoadingIndicator, LoadingIndicator = _f === void 0 ? DefaultLoadingIndicator : _f, _g = _a.Message, Message = _g === void 0 ? MessageSimple : _g, _h = _a.messageActions, messageActions = _h === void 0 ? Object.keys(MESSAGE_ACTIONS) : _h, _j = _a.messages, messages = _j === void 0 ? [] : _j, _k = _a.MessageNotification, MessageNotification = _k === void 0 ? DefaultMessageNotification : _k, _l = _a.MessageSystem, MessageSystem = _l === void 0 ? EventComponent : _l, notifications = _a.notifications, _m = _a.noGroupByUser, noGroupByUser = _m === void 0 ? false : _m, _o = _a.pinPermissions, pinPermissions = _o === void 0 ? defaultPinPermissions : _o, t = _a.t, _p = _a.threadList, threadList = _p === void 0 ? false : _p, _q = _a.TypingIndicator, TypingIndicator = _q === void 0 ? DefaultTypingIndicator : _q, _r = _a.unsafeHTML, unsafeHTML = _r === void 0 ? false : _r;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "str-chat__list " + (this.props.threadList ? 'str-chat__list--thread' : ''), ref: this.messageList },
                React.createElement(MessageListInner, { bottomRef: this.bottomRef, channel: this.props.channel, client: this.props.client, DateSeparator: DateSeparator, disableDateSeparator: this.props.disableDateSeparator, EmptyStateIndicator: EmptyStateIndicator, HeaderComponent: this.props.HeaderComponent, headerPosition: this.props.headerPosition, hideDeletedMessages: this.props.hideDeletedMessages, hideNewMessageSeparator: this.props.hideNewMessageSeparator, internalInfiniteScrollProps: __assign({ hasMore: this.props.hasMore, isLoading: this.props.loadingMore, listenToScroll: this.listenToScroll, loader: (React.createElement(Center, { key: 'loadingindicator' },
                            React.createElement(LoadingIndicator, { size: 20 }))), loadMore: this.loadMore }, internalInfiniteScrollProps), internalMessageProps: {
                        additionalMessageInputProps: this.props.additionalMessageInputProps,
                        addNotification: addNotification,
                        Attachment: Attachment,
                        Avatar: Avatar,
                        channel: this.props.channel,
                        getFlagMessageErrorNotification: this.props.getFlagMessageErrorNotification,
                        getFlagMessageSuccessNotification: this.props.getFlagMessageSuccessNotification,
                        getMuteUserErrorNotification: this.props.getMuteUserErrorNotification,
                        getMuteUserSuccessNotification: this.props.getMuteUserSuccessNotification,
                        getPinMessageErrorNotification: this.props.getPinMessageErrorNotification,
                        members: this.props.members,
                        Message: Message,
                        messageActions: messageActions,
                        messageListRect: this.state.messageListRect,
                        mutes: this.props.mutes,
                        onMentionsClick: this.props.onMentionsClick,
                        onMentionsHover: this.props.onMentionsHover,
                        onUserClick: this.props.onUserClick,
                        onUserHover: this.props.onUserHover,
                        openThread: this.props.openThread,
                        pinPermissions: pinPermissions,
                        removeMessage: this.props.removeMessage,
                        retrySendMessage: this.props.retrySendMessage,
                        unsafeHTML: unsafeHTML,
                        updateMessage: this.props.updateMessage,
                        watchers: this.props.watchers,
                    }, messages: messages, MessageSystem: MessageSystem, noGroupByUser: noGroupByUser, onMessageLoadCaptured: this.onMessageLoadCaptured, read: this.props.read, threadList: threadList, TypingIndicator: TypingIndicator })),
            React.createElement("div", { className: 'str-chat__list-notifications' },
                notifications.map(function (notification) { return (React.createElement(CustomNotification, { active: true, key: notification.id, type: notification.type }, notification.text)); }),
                React.createElement(ConnectionStatus, null),
                React.createElement(MessageNotification, { onClick: this.goToNewMessages, showNotification: this.state.newMessagesNotification }, t('New Messages!')))));
    };
    MessageListWithContext.defaultProps = {
        messages: [],
        scrolledUpThreshold: 200,
        threadList: false,
    };
    return MessageListWithContext;
}(PureComponent));
/**
 * The MessageList component renders a list of Messages.
 * It is a consumer of the [ChannelContext](https://getstream.github.io/stream-chat-react/#section-channelcontext).
 * @example ./MessageList.md
 */
export var MessageList = function (props) {
    var _a = useChannelContext(), channelClient = _a.client, // eslint-disable-line
    typing = _a.typing, // eslint-disable-line
    channelContext = __rest(_a, ["client", "typing"]);
    var client = useChatContext().client;
    var translation = useTranslationContext();
    return React.createElement(MessageListWithContext, __assign({ client: client }, channelContext, translation, props));
};
